import { IRawStyle, Separator } from "@fluentui/react";
import React, { FunctionComponent, ReactElement } from "react";

import { ButtonRenderProps } from "../inputs/button/ButtonRenderProps";
import { ElevatedStack } from "../layouts/stack/ElevatedStack";
import { Stack } from "../layouts/stack/Stack";
import { Shimmer } from "../progress/Shimmer";
import { Text } from "./Text";

export type ContentSectionProps = React.PropsWithChildren<{
    header: string | ReactElement;
    buttons?: ButtonRenderProps[];
    isLoading?: boolean;
    loader?: ReactElement;
    style?: IRawStyle;
    childrenWrapperStyle?: IRawStyle;
    testId?: string;
}>;

export const ContentSection: FunctionComponent<ContentSectionProps> = ({
    header,
    buttons,
    isLoading,
    loader,
    style,
    childrenWrapperStyle,
    children,
    testId
}: ContentSectionProps) => {
    const loaderTestId = testId ? `${testId}-loader` : undefined;

    return (
        <ElevatedStack styles={{ root: { ...style } }} testId={testId} isLoading={isLoading}>
            <Stack tokens={{ childrenGap: 10 }}>
                <Stack>
                    <Stack horizontal={true} horizontalAlign="space-between">
                        {typeof header === "string" ? <Text variant="large">{header}</Text> : header}
                        {buttons && !isLoading && (
                            <Stack horizontal={true} tokens={{ childrenGap: 5 }}>
                                {buttons.map((buttonProps: ButtonRenderProps, index: number) => (
                                    <React.Fragment key={index}>{buttonProps.render(buttonProps)}</React.Fragment>
                                ))}
                            </Stack>
                        )}
                    </Stack>
                    <Separator />
                </Stack>
                <Stack styles={{ root: { marginBottom: 10, ...childrenWrapperStyle } }}>
                    {isLoading && (loader || <Shimmer testId={loaderTestId} />)}
                    {!isLoading && children}
                </Stack>
            </Stack>
        </ElevatedStack>
    );
};
